var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillremaingfield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 9.33333C5.33301 6.81867 5.33301 5.56267 6.11434 4.78133C6.89567 4 8.15167 4 10.6663 4H21.333C23.8477 4 25.1037 4 25.885 4.78133C26.6663 5.56267 26.6663 6.81867 26.6663 9.33333V20C26.6663 23.7707 26.6663 25.6573 25.4943 26.828C24.3237 28 22.437 28 18.6663 28H13.333C9.56234 28 7.67567 28 6.50501 26.828C5.33301 25.6573 5.33301 23.7707 5.33301 20V9.33333Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.0003V28.0003M12 24.0003V28.0003M12 10.667H20M12 16.0003H20",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillremaingfield);
export default __webpack_public_path__ + "static/media/fill remaing field.ac878cd6551096c1c0eba23fa541d373.svg";
export { ForwardRef as ReactComponent };